import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import LoginPage from "./pages/LoginPage";
import AdminDashboard from "./pages/admin/AdminDashboard";
import EmployeeDirectory from "./pages/admin/EmployeeDirectory";
import AddEmployee from "./pages/admin/AddEmployee";
import LeaveManagement from "./pages/admin/LeaveManagement";
import AttendanceDashboard from "./pages/admin/AttendanceDashboard";
import TaskManagement from "./pages/admin/TaskManagement";
import EmployeeReport from "./pages/admin/EmployeeReport";
import Reports from "./pages/admin/Reports";
import EmployeeDashboard from "./pages/employee/EmployeeDashboard";
import TimeTracking from "./pages/employee/TimeTracking";
import LeaveRequests from "./pages/employee/LeaveRequests";
import TaskBoard from "./pages/employee/TaskBoard";
import "./App.css";

const A = (role, El) => (
  <ProtectedRoute role={role}><El /></ProtectedRoute>
);

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/admin/dashboard" element={A("admin", AdminDashboard)} />
          <Route path="/admin/employees" element={A("admin", EmployeeDirectory)} />
          <Route path="/admin/employees/new" element={A("admin", AddEmployee)} />
          <Route path="/admin/employees/:id/edit" element={A("admin", AddEmployee)} />
          <Route path="/admin/employees/:id/report" element={A("admin", EmployeeReport)} />
          <Route path="/admin/leaves" element={A("admin", LeaveManagement)} />
          <Route path="/admin/attendance" element={A("admin", AttendanceDashboard)} />
          <Route path="/admin/tasks" element={A("admin", TaskManagement)} />
          <Route path="/admin/reports" element={A("admin", Reports)} />
          <Route path="/employee/dashboard" element={A("employee", EmployeeDashboard)} />
          <Route path="/employee/attendance" element={A("employee", TimeTracking)} />
          <Route path="/employee/leaves" element={A("employee", LeaveRequests)} />
          <Route path="/employee/tasks" element={A("employee", TaskBoard)} />
          <Route path="/" element={<Navigate to="/login" replace />} />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
